import axios from "utils/axios";
import { routes } from "api/routes";

export const apiGetOptionStrategies = async () => {
  const { data } = await axios.get(routes.getOptionStrategies);
  return data;
};

export const apiGetOptionStrategyDetails = async (strategyId) => {
  const { data } = await axios.get(routes.getOptionStrategyDetails, {
    params: { strategyId },
  });
  return data;
};

export const apiCreateOptionStrategy = async (strategy) => {
  const { data } = await axios.post(routes.createOptionStrategy, strategy);
  return data;
};

export const apiUpdateOptionStrategy = async (strategyId, changes) => {
  const { data } = await axios.put(routes.updateOptionStrategy, changes, {
    params: { strategyId },
  });
  return data;
};

// deletes the strategy and all of its trades and activity; onlyIfNoTrades
// makes the backend refuse when the strategy has any trades
export const apiDeleteOptionStrategy = async (
  strategyId,
  { onlyIfNoTrades = false } = {},
) => {
  const { data } = await axios.delete(routes.deleteOptionStrategy, {
    params: { strategyId, ...(onlyIfNoTrades && { onlyIfNoTrades: true }) },
  });
  return data;
};

export const apiConfirmOptionBuy = async (fill) => {
  const { data } = await axios.post(routes.confirmOptionBuy, fill);
  return data;
};

export const apiDismissOptionBuy = async (tradeId) => {
  const { data } = await axios.post(routes.dismissOptionBuy, { tradeId });
  return data;
};

export const apiConfirmOptionSell = async (fill) => {
  const { data } = await axios.post(routes.confirmOptionSell, fill);
  return data;
};

export const apiLogOptionTrade = async (trade) => {
  const { data } = await axios.post(routes.logOptionTrade, trade);
  return data;
};

// closes any open option position (advised or not); premium 0 = expired
export const apiCloseOptionTrade = async (trade) => {
  const { data } = await axios.post(routes.closeOptionTrade, trade);
  return data;
};

// manually logged trades only
// every option trade of the user (all statuses), with strategy name/symbol
export const apiGetOptionTrades = async () => {
  const { data } = await axios.get(routes.getOptionTrades);
  return data;
};

export const apiDeleteOptionTrade = async (tradeId) => {
  const { data } = await axios.delete(routes.deleteOptionTrade, {
    params: { tradeId },
  });
  return data;
};

// AutoTrader sells the position (automated strategies, like the Telegram button)
export const apiTriggerOptionSell = async (tradeId) => {
  const { data } = await axios.post(routes.triggerOptionSell, { tradeId });
  return data;
};
